import { IconAlertCircle } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';

// The named org-budget refusal (arc 101 slice 02, #3737): an ORG account whose
// box budget is 0. Shared by the Fleet view (said before anyone clicks "Connect
// a machine") and the Connect a machine dialog (its plan line, and a refused
// mint, via <ConnectPlanLine/>). Presenter.
//
// It names BOTH fixes because neither lives where it is shown: seats are bought
// on the billing page (linked), and a grant on the account is a platform
// operator's act.

export function OrgUnfundedAlert(): JSX.Element {
  return (
    <div class="alert alert--icon alert--destructive" role="alert">
      <IconAlertCircle />
      <p class="alert__title">{t('fleet.addbox.org_unfunded_title')}</p>
      <p class="alert__desc">{t('fleet.addbox.org_unfunded_desc')}</p>
      <p class="alert__desc">
        <a href={orgHref('/account/billing')}>{t('fleet.addbox.org_unfunded_billing')}</a>
      </p>
    </div>
  );
}
